import { MovSimplesProdutoModel } from "api/cardapio/models/produto/mov-simples-produto-model";
import { ProdutoModel } from "api/cardapio/models/produto/produto-model";
import { useMemo } from "react";
import { useCardapioDadosStore } from "services/store/cardapio-dados-store";
import { useDadosDeliveryStore } from "services/store/dados-delivery";
import { useSacolaAbertaStore } from "services/store/sacola-aberta";
import { DadosDelivery, EnumOpcoesDelivery, ItemSacola, useEsvaziarSacola, useObterSacola } from "storage";
import { generatePedidoWhatsApp } from "utils";

export const usePedidoWhatsapp = () => {
    const { cardapioDados } = useCardapioDadosStore()
    const [esvaziarSacola] = useEsvaziarSacola();
    const fecharSacola = useSacolaAbertaStore(state => state.fecharSacola)
    const itens = useObterSacola(cardapioDados?.empresa.id || '');


    const total = useMemo(() => {
        let total =
            (itens?.data || ([] as ProdutoModel[])).length > 0
                ? itens?.data?.filter(x => x.indFin).map((item) => {
                    if (item.vUnCom === 0)
                        return 0;
                    return item.vFinal!
                }).reduce((prev, next) => prev + next, 0)
                : 0;

        return (total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }, [itens?.data]);

    const totalItens = useMemo(() => {
        let total =
            (itens?.data || ([] as ItemSacola[])).length > 0
                ? itens?.data?.map((item) => item.qCom).reduce((prev, next) => prev! + next!, 0)
                : 0;

        return total || 0;
    }, [itens?.data]);

    const fazerPedidoWhatsApp = (integrado?: boolean) => {
        const { enderecoDelivery, tipoDelivery, dadosWhatsapp } = useDadosDeliveryStore.getState();

        const dadosDelivery: DadosDelivery = {
            bairro: enderecoDelivery?.bairro || '',
            cep: enderecoDelivery?.cep || '',
            cpl: enderecoDelivery?.complemento || '',
            municipio: enderecoDelivery?.xMun || '',
            nro: enderecoDelivery?.numero || '',
            lgr: enderecoDelivery?.logradouro || '',
            referencia: enderecoDelivery?.referencia || '',
            uf: enderecoDelivery?.uf || '',
            documento: dadosWhatsapp?.documento || '',
            nome: dadosWhatsapp?.nome || '',
            telefone: dadosWhatsapp?.telefone || '',
            tipo: tipoDelivery ?? EnumOpcoesDelivery.Entrega,
        }

        let link = generatePedidoWhatsApp().gerarPedido(
            integrado || false,
            cardapioDados?.empresa?.nomeFantasia || '',
            cardapioDados?.empresa?.fone || '',
            itens?.data || ([] as MovSimplesProdutoModel[]),
            totalItens,
            total,
            cardapioDados?.configuracoes?.permiteEntrega === true,
            cardapioDados?.configuracoes?.permiteRetirada === true,
            dadosDelivery,
        );
        window.open(link, '_blank');
        if (!(integrado ?? false)) {
            esvaziarSacola({ empresaId: cardapioDados?.empresa?.id || '' });
            fecharSacola()
        }
    };

    return { fazerPedidoWhatsApp }
}